// import oct2021 from './monthlyJSON/2021_10.json'
// import nov2021 from './monthlyJSON/2021_11.json'
// import dec2021 from './monthlyJSON/2021_12.json'
// import may22022 from './monthlyJSON/2021_1234.json'
// import jan2022 from './monthlyJSON/2022_1.json'
// import feb2022 from './monthlyJSON/2022_2.json'
// import mar2022 from './monthlyJSON/2022_3.json'
// import apr2022 from './monthlyJSON/2022_4.json'
// import may2022 from './monthlyJSON/2022_5.json'
// import Y_2022_7to2023_3_7 from './monthlyJSON/2022_7to2023_3_7.json'
// import Y_20021_123 from './monthlyJSON/20021_123.json'
// import newleadf from './monthlyJSON/newleadf.json'
import L_12Aug_14Aug from "./daily/L_12Aug_14Aug.json"


const data  =[
    // ...may2022,
    // ...apr2022,
    // ...mar2022,
    // ...feb2022,
    // ...jan2022,
    // ...dec2021,
    // ...nov2021,
    // ...oct2021,
    // ...may22022,
    // ...Y_2022_7to2023_3_7,
    // ...Y_20021_123,
    // ...newleadf,
    ...L_12Aug_14Aug
]

export default data;